require('./style.less');

var Marionette = require('marionette'),
    SpinView = require('../../../common/spinView');


module.exports = Marionette.LayoutView.extend({

    initialize: function( options ) {

        this.channel = options.channel;

        // Note: hide and show require requestAnimationFrame from callers
        this.listenTo( this.channel, 'findAndRedact:showSpinner', this.showSpinner );
        this.listenTo( this.channel, 'findAndRedact:hideSpinner', this.hideSpinner );

    },

    template: require('./template.hbs'),


    regions: {
        spinnerRegion:              '#fr-spinner-region'
    },

    onBeforeShow: function() {

        this._showHiddenSpinView();

    },

    // With newer browsers, we should move to CSS solution ...
    // Now starts hidden with param
    _showHiddenSpinView: function() {
        this.spinnerRegion.show( new SpinView({
            length: 3,
            radius: 3,
            width: 1
        }, true) );

    },

    showSpinner: function() {

        this.spinnerRegion.currentView.triggerMethod('start');
    },

    hideSpinner: function() {

        this.spinnerRegion.currentView.triggerMethod('stop');

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/header/view.js
 ** module id = 588
 ** module chunks = 0
 **/